import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const GET_IMPORT_DATA_CLIENT_SUCCESS = 'GET_IMPORT_DATA_CLIENT_SUCCESS';
export const GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS = 'GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS';
export const GET_IMPORT_DATA_ALL_SUCCESS = 'GET_IMPORT_DATA_ALL_SUCCESS';
export const GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS = 'GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS';
export const GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS = 'GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO';

export const getImportDataClient = () =>
    network.actionWrapper(`${config.getAppUrl()}/reportingtool/getImportDataClient`, {
      begin: ACTION_BEGIN,
      success: GET_IMPORT_DATA_CLIENT_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const getImportDataClientWithTimePeriod = (startDate, endDate) =>
    network.actionWrapper(`${config.getAppUrl()}/reportingtool/getImportDataClient/${startDate}:${endDate}`, {
      begin: ACTION_BEGIN,
      success: GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const getImportDataAll = () =>
    network.actionWrapper(`${config.getAppUrl()}/reportingtool/getImportDataAll`, {
      begin: ACTION_BEGIN,
      success: GET_IMPORT_DATA_ALL_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const getImportDataAllWithTimePeriod = (startDate, endDate) =>
    network.actionWrapper(`${config.getAppUrl()}/reportingtool/getImportDataAll/${startDate}:${endDate}`, {
      begin: ACTION_BEGIN,
      success: GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS,
      failure: ACTION_FAILURE,
    });

export const getImportDataForSubscriptionInfo = (startDate, endDate) =>
  network.actionWrapper(`${config.getAppUrl()}/reportingtool/getImportDataAll/${startDate}:${endDate}`, {
    begin: ACTION_BEGIN,
    success: GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS,
    failure: ACTION_FAILURE,
  });
